(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-comparison-table"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('[data-grooni-compare-wrap]').forEach(function (wrap) {
      if (wrap.dataset.grooniInit === '1') return;
      wrap.dataset.grooniInit = '1';

      function update() {
        var canScroll = wrap.scrollWidth > wrap.clientWidth + 2;
        wrap.classList.toggle('is-scrollable', canScroll);
        var atEnd = wrap.scrollLeft + wrap.clientWidth >= wrap.scrollWidth - 4;
        wrap.classList.toggle('is-scrolled-end', atEnd);
      }
      wrap.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-experts"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCarousel(section) {
    if (section.dataset.grooniInit === '1') return;
    section.dataset.grooniInit = '1';
    var track   = section.querySelector('[data-grooni-experts-track]');
    var prevBtn = section.querySelector('[data-grooni-experts-prev]');
    var nextBtn = section.querySelector('[data-grooni-experts-next]');
    if (!track || !prevBtn || !nextBtn) return;

    function updateNav() {
      var max = track.scrollWidth - track.clientWidth - 1;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= max;
    }
    function step() {
      var first = track.querySelector('.grooni-experts__card');
      return first ? first.getBoundingClientRect().width + 16 : track.clientWidth;
    }
    prevBtn.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    nextBtn.addEventListener('click', function () { track.scrollBy({ left:  step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();
  }
  function init() {
    document.querySelectorAll('[data-grooni-experts]').forEach(initCarousel);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-home-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('[data-grooni-hero-video]').forEach(function (v) {
      // Force the autoplay-friendly properties (some themes' JS resets them)
      v.muted = true;
      v.defaultMuted = true;
      v.loop = true;
      v.playsInline = true;
      v.setAttribute('muted', '');
      v.setAttribute('loop', '');
      v.setAttribute('playsinline', '');

      function tryPlay() {
        var p = v.play();
        if (p && typeof p.catch === 'function') {
          p.catch(function () {
            // Browsers blocking autoplay — try again on first user interaction
            var resume = function () {
              v.play().catch(function(){});
              document.removeEventListener('touchstart', resume, true);
              document.removeEventListener('click', resume, true);
              document.removeEventListener('scroll', resume, true);
            };
            document.addEventListener('touchstart', resume, { once: true, capture: true });
            document.addEventListener('click', resume, { once: true, capture: true });
            document.addEventListener('scroll', resume, { once: true, capture: true });
          });
        }
      }

      // Attempt play immediately and again after metadata loads
      tryPlay();
      v.addEventListener('loadedmetadata', tryPlay);
      v.addEventListener('canplay', tryPlay);
      // Re-loop in case the loop attribute is stripped by some script
      v.addEventListener('ended', function () { v.currentTime = 0; v.play().catch(function(){}); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-infographics"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('[data-grooni-infogs]').forEach(function (section) {
      var tabs   = section.querySelectorAll('[data-grooni-infogs-tab]');
      var panels = section.querySelectorAll('[data-grooni-infogs-panel]');

      function activate(blockId) {
        tabs.forEach(function (t) {
          var match = t.getAttribute('data-grooni-infogs-tab') === blockId;
          t.classList.toggle('grooni-infogs__tab--active', match);
          t.setAttribute('aria-selected', match ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var match = p.getAttribute('data-grooni-infogs-panel') === blockId;
          p.classList.toggle('grooni-infogs__panel--active', match);
          if (match) p.removeAttribute('hidden');
          else p.setAttribute('hidden', '');
        });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          activate(tab.getAttribute('data-grooni-infogs-tab'));
        });
        tab.addEventListener('keydown', function (e) {
          var keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
          if (keys.indexOf(e.key) === -1) return;
          e.preventDefault();
          var arr = Array.prototype.slice.call(tabs);
          var idx = arr.indexOf(tab);
          var next;
          if (e.key === 'ArrowLeft')  next = arr[(idx - 1 + arr.length) % arr.length];
          if (e.key === 'ArrowRight') next = arr[(idx + 1) % arr.length];
          if (e.key === 'Home')       next = arr[0];
          if (e.key === 'End')        next = arr[arr.length - 1];
          if (next) {
            next.focus();
            activate(next.getAttribute('data-grooni-infogs-tab'));
          }
        });
      });

      // ───── Lightbox / zoom ─────
      var lightbox     = section.querySelector('[data-grooni-infogs-lightbox]');
      var lightboxImg  = section.querySelector('[data-grooni-infogs-lightbox-img]');
      var lightboxClose= section.querySelector('[data-grooni-infogs-close]');

      function openLightbox(src, alt) {
        if (!lightbox || !lightboxImg) return;
        lightboxImg.src = src;
        lightboxImg.alt = alt || '';
        lightboxImg.removeAttribute('data-zoomed');
        lightbox.removeAttribute('hidden');
        // Force reflow so the transition runs
        void lightbox.offsetWidth;
        lightbox.setAttribute('data-grooni-infogs-lightbox-open', '');
        document.body.classList.add('grooni-infogs-lightbox-open');
      }
      function closeLightbox() {
        if (!lightbox) return;
        lightbox.removeAttribute('data-grooni-infogs-lightbox-open');
        document.body.classList.remove('grooni-infogs-lightbox-open');
        setTimeout(function () {
          lightbox.setAttribute('hidden', '');
          if (lightboxImg) lightboxImg.src = '';
        }, 220);
      }

      section.querySelectorAll('[data-grooni-infogs-zoom]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          openLightbox(btn.getAttribute('data-src'), btn.getAttribute('data-alt'));
        });
      });
      if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
      if (lightbox) {
        lightbox.addEventListener('click', function (e) {
          // Click outside the image closes
          if (e.target === lightbox || e.target.classList.contains('grooni-infogs__lightbox-scroll')) {
            closeLightbox();
          }
        });
      }
      if (lightboxImg) {
        lightboxImg.addEventListener('click', function () {
          if (lightboxImg.hasAttribute('data-zoomed')) lightboxImg.removeAttribute('data-zoomed');
          else lightboxImg.setAttribute('data-zoomed', '');
        });
      }
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && lightbox && lightbox.hasAttribute('data-grooni-infogs-lightbox-open')) {
          closeLightbox();
        }
      });

      // ───── Download (force download via blob — Shopify CDN ignores `download` attr cross-origin) ─────
      section.querySelectorAll('[data-grooni-infogs-download]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          var url = a.getAttribute('href');
          var name = a.getAttribute('data-filename') || 'infographic.jpg';
          if (!url) return;
          // Try blob download for same-origin & CORS-enabled URLs
          e.preventDefault();
          fetch(url, { mode: 'cors' })
            .then(function (r) {
              if (!r.ok) throw new Error('Fetch failed');
              return r.blob();
            })
            .then(function (blob) {
              var objUrl = URL.createObjectURL(blob);
              var tmp = document.createElement('a');
              tmp.href = objUrl;
              tmp.download = name;
              document.body.appendChild(tmp);
              tmp.click();
              document.body.removeChild(tmp);
              setTimeout(function () { URL.revokeObjectURL(objUrl); }, 1000);
            })
            .catch(function () {
              // Fallback: open in new tab — user can save manually
              window.open(url, '_blank', 'noopener');
            });
        });
      });

      // ───── Share (Web Share API → fallback to copy-link) ─────
      section.querySelectorAll('[data-grooni-infogs-share]').forEach(function (btn) {
        var label = btn.querySelector('[data-grooni-infogs-share-label]');
        btn.addEventListener('click', function () {
          var title = btn.getAttribute('data-title') || document.title;
          var url   = btn.getAttribute('data-url')   || window.location.href;
          var pageUrl = window.location.href;

          if (navigator.share) {
            navigator.share({
              title: title,
              text: title,
              url: pageUrl
            }).catch(function () { /* user cancelled */ });
          } else if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(pageUrl).then(function () {
              if (label) {
                var orig = label.textContent;
                label.textContent = 'Copied!';
                setTimeout(function () { label.textContent = orig; }, 1500);
              }
            }).catch(function () {});
          } else {
            // Last-resort fallback
            window.prompt('Copy this link:', pageUrl);
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-personas-grid-grounding"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('[data-grooni-prsng]').forEach(function (section) {
      if (section.dataset.grooniPrsngBound === '1') return;
      section.dataset.grooniPrsngBound = '1';

      var cards = section.querySelectorAll('[data-grooni-prsng-card]');
      if (!cards.length) return;

      function revealAll() {
        cards.forEach(function (c) { c.classList.add('is-visible'); });
      }

      section.classList.add('js-ready');

      // Scroll-in stagger
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              io.unobserve(entry.target);
            }
          });
        }, { threshold: 0, rootMargin: '0px 0px 100px 0px' });
        cards.forEach(function (c) { io.observe(c); });
        setTimeout(revealAll, 1500);
      } else {
        revealAll();
      }

      // Click-to-expand (accordion)
      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          var sel = window.getSelection && window.getSelection();
          if (sel && sel.toString && sel.toString().length > 0) return;

          var isOpen = card.getAttribute('aria-expanded') === 'true';
          cards.forEach(function (other) {
            if (other !== card) other.setAttribute('aria-expanded', 'false');
          });
          card.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        });
      });

      // Scroll-spotlight (driven by viewport-center crossing)
      var spotlightMargin = 60;
      var rafQueued = false;
      function updateSpotlight() {
        if (rafQueued) return;
        rafQueued = true;
        requestAnimationFrame(function () {
          rafQueued = false;
          var vpCenter = window.innerHeight / 2;
          cards.forEach(function (c) {
            var rect = c.getBoundingClientRect();
            var inZone =
              (rect.top - spotlightMargin) < vpCenter &&
              (rect.bottom + spotlightMargin) > vpCenter;
            c.classList.toggle('scroll-active', inZone);
          });
        });
      }
      window.addEventListener('scroll', updateSpotlight, { passive: true });
      window.addEventListener('resize', updateSpotlight);
      updateSpotlight();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-personas-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('[data-grooni-personas]').forEach(function (section) {
      if (section.dataset.grooniPersonasBound === '1') return;
      section.dataset.grooniPersonasBound = '1';

      var cards = section.querySelectorAll('[data-grooni-personas-card]');
      if (!cards.length) return;

      function revealAll() {
        cards.forEach(function (c) { c.classList.add('is-visible'); });
      }

      // Hide cards now so the fade-in animation has something to animate
      // FROM. (CSS only hides them once .js-ready is on the section, so
      // they were visible by default if JS hadn't yet loaded.)
      section.classList.add('js-ready');

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              io.unobserve(entry.target);
            }
          });
        }, { threshold: 0, rootMargin: '0px 0px 100px 0px' });
        cards.forEach(function (c) { io.observe(c); });

        // Fallback safety net: if for some reason the observer never
        // fires (browser bug, off-screen content, etc.), reveal all
        // cards after 1.5s so users always see them.
        setTimeout(revealAll, 1500);
      } else {
        revealAll();
      }

      // Click-to-expand (accordion)
      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          var sel = window.getSelection && window.getSelection();
          if (sel && sel.toString && sel.toString().length > 0) return;

          var isOpen = card.getAttribute('aria-expanded') === 'true';
          cards.forEach(function (other) {
            if (other !== card) other.setAttribute('aria-expanded', 'false');
          });
          card.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        });
      });

      // ── Scroll-spotlight ──
      // Highlight any card whose vertical extent crosses (or is near)
      // the viewport's vertical center. On desktop grid this naturally
      // lights up one full row at a time; on mobile (stacked) one card
      // at a time. The margin makes the active zone forgiving so cards
      // don't flicker on/off near the threshold.
      var spotlightMargin = 60;
      var rafQueued = false;
      function updateSpotlight() {
        if (rafQueued) return;
        rafQueued = true;
        requestAnimationFrame(function () {
          rafQueued = false;
          var vpCenter = window.innerHeight / 2;
          cards.forEach(function (c) {
            var rect = c.getBoundingClientRect();
            var inZone =
              (rect.top - spotlightMargin) < vpCenter &&
              (rect.bottom + spotlightMargin) > vpCenter;
            c.classList.toggle('scroll-active', inZone);
          });
        });
      }
      window.addEventListener('scroll', updateSpotlight, { passive: true });
      window.addEventListener('resize', updateSpotlight);
      updateSpotlight();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pillars-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSection(section) {
    if (section.dataset.grooniInit === '1') return;
    section.dataset.grooniInit = '1';

    var tabs   = section.querySelectorAll('[data-grooni-pt-tab]');
    var panels = section.querySelectorAll('[data-grooni-pt-panel]');
    var track  = section.querySelector('[data-grooni-pt-track]');
    var prev   = section.querySelector('[data-grooni-pt-prev]');
    var next   = section.querySelector('[data-grooni-pt-next]');
    var mcWrap   = section.querySelector('[data-grooni-pt-mcarousel]');
    var mcTrack  = section.querySelector('[data-grooni-pt-mcarousel-track]');
    var mcSlides = section.querySelectorAll('[data-grooni-pt-mcarousel-slide]');

    function activate(idx) {
      tabs.forEach(function (t) {
        var on = t.dataset.grooniPtTab === String(idx);
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var on = p.dataset.grooniPtPanel === String(idx);
        p.classList.toggle('is-active', on);
        if (on) p.removeAttribute('hidden');
        else p.setAttribute('hidden', '');
      });
      // Sync the mobile image carousel slide highlight
      mcSlides.forEach(function (s) {
        s.classList.toggle('is-active', s.dataset.index === String(idx));
      });
      // Scroll the active tab into view in the strip
      var activeTab = section.querySelector('[data-grooni-pt-tab="' + idx + '"]');
      if (activeTab && track) {
        var tabRect = activeTab.getBoundingClientRect();
        var trackRect = track.getBoundingClientRect();
        if (tabRect.left < trackRect.left || tabRect.right > trackRect.right) {
          activeTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }
      // Scroll mobile carousel to matching slide (if it's not already there)
      if (mcTrack) {
        var slideWidth = mcTrack.clientWidth;
        if (slideWidth) {
          var targetLeft = idx * slideWidth;
          if (Math.abs(mcTrack.scrollLeft - targetLeft) > 4) {
            mcTrack.scrollTo({ left: targetLeft, behavior: 'smooth' });
          }
        }
      }
    }

    // Mobile image carousel — swipe → change pillar
    if (mcTrack && mcSlides.length) {
      var rafTimer = null;
      mcTrack.addEventListener('scroll', function () {
        if (mcWrap) mcWrap.classList.add('has-scrolled');
        if (rafTimer) cancelAnimationFrame(rafTimer);
        rafTimer = requestAnimationFrame(function () {
          var slideWidth = mcTrack.clientWidth;
          if (!slideWidth) return;
          var idx = Math.round(mcTrack.scrollLeft / slideWidth);
          if (idx >= 0 && idx < mcSlides.length) {
            // Only call activate if it actually changed — avoids feedback loop
            // with our own scrollTo() in activate().
            var current = section.querySelector('[data-grooni-pt-panel].is-active');
            if (!current || current.dataset.grooniPtPanel !== String(idx)) {
              activate(idx);
            }
          }
        });
      }, { passive: true });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.dataset.grooniPtTab);
      });
    });

    function updateNavState() {
      if (!track || !prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= max;
    }
    function step() {
      var first = track.querySelector('.grooni-pillarstabs__tab');
      return first ? first.getBoundingClientRect().width + 12 : track.clientWidth * 0.6;
    }
    if (prev && track) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next && track) next.addEventListener('click', function () { track.scrollBy({ left:  step() * 2, behavior: 'smooth' }); });
    if (track) {
      track.addEventListener('scroll', updateNavState, { passive: true });
      window.addEventListener('resize', updateNavState);
      updateNavState();
    }
  }

  function init() {
    document.querySelectorAll('[data-grooni-pillarstabs]').forEach(initSection);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-podcasts"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('[data-grooni-pod]').forEach(function (card) {
      // Avoid double-binding when section reloads in the editor
      if (card.dataset.grooniBound === '1') return;
      card.dataset.grooniBound = '1';

      var poster   = card.querySelector('[data-grooni-pod-play]');
      var template = card.querySelector('[data-grooni-pod-template]');
      if (!poster || !template) return;

      poster.addEventListener('click', function () {
        var media = poster.parentNode;
        var frag  = template.content.cloneNode(true);
        // Pause any other podcast videos playing on this page
        document.querySelectorAll('.grooni-pods__video').forEach(function (v) { try { v.pause(); } catch (e) {} });
        // Replace poster button with the video
        poster.remove();
        media.appendChild(frag);
        var v = media.querySelector('video');
        if (v) {
          v.play().catch(function () {});
        }
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); return; }
    document.addEventListener('DOMContentLoaded', fn);
  }

  function parseMoneyFormat(raw) {
    try { return JSON.parse(raw) || ('$' + String.fromCharCode(123,123) + 'amount' + String.fromCharCode(125,125)); } catch (e) { return ('$' + String.fromCharCode(123,123) + 'amount' + String.fromCharCode(125,125)); }
  }

  function formatMoney(cents, fmt) {
    var amount = (cents / 100).toFixed(2);
    var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (fmt || ('$' + String.fromCharCode(123,123) + 'amount' + String.fromCharCode(125,125)))
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withCommas.split('.')[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withCommas.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withCommas.split('.')[0]);
  }

  function initSection(section) {
    if (section.dataset.grooniInit === '1') return;
    section.dataset.grooniInit = '1';

    /* ----- Variant data ----- */
    var dataEl    = section.querySelector('[data-grooni-variant-data]');
    var fmtEl     = section.querySelector('[data-grooni-money-format]');
    var fmtElCcy  = section.querySelector('[data-grooni-money-with-currency-format]');
    var variants  = [];
    var moneyFmt    = ('$' + String.fromCharCode(123,123) + 'amount' + String.fromCharCode(125,125));
    var moneyFmtCcy = moneyFmt;
    try { variants = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (e) { variants = []; }
    if (fmtEl)    moneyFmt    = parseMoneyFormat(fmtEl.textContent);
    if (fmtElCcy) moneyFmtCcy = parseMoneyFormat(fmtElCcy.textContent);

    /* ----- Delivery estimate ----- */
    function addDays(date, days, businessOnly) {
      var d = new Date(date.getTime());
      var added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        var day = d.getDay();
        if (!businessOnly || (day !== 0 && day !== 6)) {
          added++;
        }
      }
      return d;
    }
    function formatRange(min, max) {
      var fmtSame = { day: 'numeric' };
      var fmtFull = { month: 'short', day: 'numeric' };
      var sameMonth = min.getMonth() === max.getMonth();
      var minStr = min.toLocaleDateString(undefined, fmtFull);
      var maxStr = max.toLocaleDateString(undefined, sameMonth ? fmtSame : fmtFull);
      return minStr + ' – ' + maxStr;
    }
    section.querySelectorAll('[data-grooni-delivery]').forEach(function (el) {
      var minDays = parseInt(el.dataset.minDays, 10) || 2;
      var maxDays = parseInt(el.dataset.maxDays, 10) || 4;
      var business = el.dataset.businessDays === '1';
      var now = new Date();
      var minDate = addDays(now, minDays, business);
      var maxDate = addDays(now, maxDays, business);
      var datesEl = el.querySelector('[data-grooni-delivery-dates]');
      if (datesEl) datesEl.textContent = formatRange(minDate, maxDate);
    });

    /* ----- Gallery: scroll-snap stage + thumbnail nav ----- */
    var stage  = section.querySelector('[data-grooni-stage]');
    var slides = section.querySelectorAll('[data-grooni-stage-slide]');
    var thumbs = section.querySelectorAll('[data-grooni-thumb]');

    function scrollStageToIndex(idx) {
      if (!stage) return;
      var slide = slides[idx];
      if (!slide) return;
      stage.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }

    function setActiveSlideIndex(idx) {
      slides.forEach(function (s, i) {
        var active = i === idx;
        s.classList.toggle('is-active', active);
        // Auto-play any video on the active slide; pause others.
        var video = s.querySelector('[data-grooni-product-video]');
        if (video) {
          if (active) {
            try { video.play(); } catch (e) {}
          } else {
            try { video.pause(); video.currentTime = 0; } catch (e) {}
          }
        }
      });
      thumbs.forEach(function (t, i) {
        var match = i === idx;
        t.classList.toggle('is-active', match);
        t.setAttribute('aria-selected', match ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (thumb, idx) {
      thumb.addEventListener('click', function () {
        scrollStageToIndex(idx);
        setActiveSlideIndex(idx);
      });
    });

    /* ----- Main-image prev/next arrows (desktop) ----- */
    var mainPrev = section.querySelector('[data-grooni-main-prev]');
    var mainNext = section.querySelector('[data-grooni-main-next]');
    function currentSlideIndex() {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('is-active')) return i;
      }
      return 0;
    }
    if (mainPrev) {
      mainPrev.addEventListener('click', function () {
        var idx = currentSlideIndex();
        var newIdx = idx > 0 ? idx - 1 : slides.length - 1; // wrap to last
        scrollStageToIndex(newIdx);
        setActiveSlideIndex(newIdx);
      });
    }
    if (mainNext) {
      mainNext.addEventListener('click', function () {
        var idx = currentSlideIndex();
        var newIdx = idx < slides.length - 1 ? idx + 1 : 0; // wrap to first
        scrollStageToIndex(newIdx);
        setActiveSlideIndex(newIdx);
      });
    }

    // Keep thumbnail highlight in sync as the user swipes the stage.
    if (stage) {
      var rafTimer = null;
      stage.addEventListener('scroll', function () {
        if (rafTimer) cancelAnimationFrame(rafTimer);
        rafTimer = requestAnimationFrame(function () {
          var slideWidth = stage.clientWidth;
          if (!slideWidth) return;
          var idx = Math.round(stage.scrollLeft / slideWidth);
          if (idx >= 0 && idx < slides.length) {
            setActiveSlideIndex(idx);
          }
        });
      }, { passive: true });
    }

    /* ----- Thumbnail carousel arrows ----- */
    var track   = section.querySelector('[data-grooni-thumb-track]');
    var prevBtn = section.querySelector('[data-grooni-thumb-prev]');
    var nextBtn = section.querySelector('[data-grooni-thumb-next]');
    if (track && prevBtn && nextBtn) {
      function updateNavState() {
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        prevBtn.disabled = track.scrollLeft <= 0;
        nextBtn.disabled = track.scrollLeft >= maxScroll;
      }
      function step() {
        // Scroll by ~3 thumbnail widths (3 * 116 = 348)
        return Math.max(track.clientWidth * 0.7, 232);
      }
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left:  step(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', updateNavState, { passive: true });
      window.addEventListener('resize', updateNavState);
      updateNavState();
    }

    /* ----- Variant picker ----- */
    var cards        = section.querySelectorAll('[data-grooni-variant-card]');
    var variantInput = section.querySelector('[data-grooni-variant-input]');
    var priceEl      = section.querySelector('[data-grooni-price]');
    var comparePrice = section.querySelector('[data-grooni-compare-price]');
    var ctaPriceEl   = section.querySelector('[data-grooni-cta-price]');
    var ctaBtn       = section.querySelector('[data-grooni-cta]');
    var ctaTextEl    = ctaBtn ? ctaBtn.querySelector('[data-grooni-cta-text]') : null;
    var originalCtaInner = ctaTextEl ? ctaTextEl.innerHTML : '';

    function selectVariantById(id) {
      var variant = variants.find(function (v) { return v.id === id; });
      if (!variant) return;

      if (variantInput) variantInput.value = variant.id;

      cards.forEach(function (card) {
        var match = parseInt(card.dataset.variantId, 10) === id;
        card.classList.toggle('is-selected', match);
        card.setAttribute('aria-checked', match ? 'true' : 'false');
      });

      if (priceEl) priceEl.textContent = formatMoney(variant.price, moneyFmtCcy);
      if (comparePrice) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePrice.textContent = formatMoney(variant.compare_at_price, moneyFmt);
          comparePrice.removeAttribute('hidden');
        } else {
          comparePrice.setAttribute('hidden', '');
        }
      }
      if (ctaBtn && ctaTextEl) {
        if (variant.available) {
          ctaBtn.disabled = false;
          // Restore original CTA HTML, then update price inside
          ctaTextEl.innerHTML = originalCtaInner;
          var freshPriceEl = ctaTextEl.querySelector('[data-grooni-cta-price]');
          if (freshPriceEl) freshPriceEl.textContent = formatMoney(variant.price, moneyFmt);
        } else {
          ctaBtn.disabled = true;
          ctaTextEl.textContent = ctaBtn.dataset.soldOutText || 'Sold Out';
        }
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    /* Click handler on each variant button. Uses capture phase so
       it runs before any theme/jQuery listeners that may be bound
       higher up the DOM tree. Updates the hidden `name=id` input
       directly so the form submits the right variant. */
    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (card.disabled || card.classList.contains('is-unavailable')) return;
        var id = parseInt(card.dataset.variantId, 10);
        if (!id) return;
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') {
          e.stopImmediatePropagation();
        }
        selectVariantById(id);
      }, true);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-grooni-hero]').forEach(initSection);
  }

  ready(initAll);
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-research-comparison"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCompare(container) {
    if (container.dataset.grooniInit === '1') return;
    container.dataset.grooniInit = '1';

    var clip   = container.querySelector('[data-grooni-compare-clip]');
    var handle = container.querySelector('[data-grooni-compare-handle]');
    if (!clip || !handle) return;

    var startStyle = getComputedStyle(container.closest('[data-grooni-research]')).getPropertyValue('--grooni-research-start');
    var startPos = parseFloat(startStyle) || 50;
    setPosition(startPos);

    var dragging = false;

    function setPosition(percent) {
      percent = Math.max(0, Math.min(100, percent));
      container.style.setProperty('--grooni-pos',  percent + '%');
      container.style.setProperty('--grooni-clip', percent + '%');
    }

    function getClientX(e) {
      if (e.touches && e.touches.length) return e.touches[0].clientX;
      if (e.changedTouches && e.changedTouches.length) return e.changedTouches[0].clientX;
      return e.clientX;
    }

    function moveTo(e) {
      var rect = container.getBoundingClientRect();
      var x = getClientX(e) - rect.left;
      var percent = (x / rect.width) * 100;
      setPosition(percent);
    }

    function onStart(e) {
      dragging = true;
      container.classList.add('is-dragging');
      moveTo(e);
      e.preventDefault();
    }
    function onMove(e) {
      if (!dragging) return;
      moveTo(e);
    }
    function onEnd() {
      dragging = false;
      container.classList.remove('is-dragging');
    }

    container.addEventListener('mousedown',  onStart);
    document.addEventListener('mousemove',   onMove);
    document.addEventListener('mouseup',     onEnd);

    container.addEventListener('touchstart', onStart, { passive: false });
    document.addEventListener('touchmove',   onMove,  { passive: true  });
    document.addEventListener('touchend',    onEnd);

    // Keyboard support on the handle button
    var btn = handle.querySelector('.grooni-research__handle-button');
    if (btn) {
      btn.addEventListener('keydown', function (e) {
        var current = parseFloat((container.style.getPropertyValue('--grooni-pos') || '50%').replace('%', '')) || 50;
        if (e.key === 'ArrowLeft')  { setPosition(current - 5); e.preventDefault(); }
        if (e.key === 'ArrowRight') { setPosition(current + 5); e.preventDefault(); }
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-grooni-compare]').forEach(initCompare);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-sticky-cart"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var bars = document.querySelectorAll('[data-grooni-sticky]');
    if (!bars.length) return;

    bars.forEach(function (bar) {
      var mode          = bar.getAttribute('data-grooni-sticky-mode') || 'element';
      var watchSelector = bar.getAttribute('data-grooni-sticky-watch') || '[data-grooni-cta]';
      var percent       = parseFloat(bar.getAttribute('data-grooni-sticky-percent')) || 25;
      var watchEl       = document.querySelector(watchSelector);

      function show() {
        bar.setAttribute('data-grooni-sticky-visible', '');
        bar.setAttribute('aria-hidden', 'false');
        document.body.classList.add('grooni-sticky-cart-visible');
      }
      function hide() {
        bar.removeAttribute('data-grooni-sticky-visible');
        bar.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('grooni-sticky-cart-visible');
      }

      if (mode === 'percent') {
        // Show after scrolling past N% of the document height
        var onScroll = function () {
          var docHeight = Math.max(
            document.documentElement.scrollHeight,
            document.body.scrollHeight
          ) - window.innerHeight;
          if (docHeight <= 0) { show(); return; }
          var scrolled = (window.scrollY / docHeight) * 100;
          if (scrolled >= percent) show(); else hide();
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        onScroll();
      } else if (watchEl && 'IntersectionObserver' in window) {
        // Element mode — show only when the watched element is off-screen above
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting && entry.boundingClientRect.top < 0) show();
            else hide();
          });
        }, { threshold: 0, rootMargin: '0px 0px 0px 0px' });
        io.observe(watchEl);
      } else {
        // Fallback when neither watch element nor IntersectionObserver are available
        var onScrollFallback = function () {
          if (window.scrollY > 600) show(); else hide();
        };
        window.addEventListener('scroll', onScrollFallback, { passive: true });
        onScrollFallback();
      }

      // Variant change → update price + button state
      var select   = bar.querySelector('[data-grooni-sticky-variant]');
      var priceEl  = bar.querySelector('[data-grooni-sticky-price]');
      var compEl   = bar.querySelector('[data-grooni-sticky-compare]');
      var atcBtn   = bar.querySelector('[data-grooni-sticky-atc]');

      if (select && priceEl) {
        select.addEventListener('change', function () {
          var opt = select.options[select.selectedIndex];
          var price     = opt.getAttribute('data-price');
          var compare   = opt.getAttribute('data-compare');
          var onSale    = opt.getAttribute('data-on-sale') === 'true';
          var available = opt.getAttribute('data-available') === 'true';

          if (price) priceEl.textContent = price;
          if (compEl) {
            if (onSale && compare) {
              compEl.textContent = compare;
              compEl.removeAttribute('hidden');
            } else {
              compEl.setAttribute('hidden', '');
            }
          }
          if (atcBtn) {
            atcBtn.disabled = !available;
            atcBtn.textContent = available ? (atcBtn.getAttribute('data-label') || 'Add to Cart') : 'Sold Out';
          }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-init when the section reloads in the theme editor
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-tech-features-grounding"] && !Shopify.designMode) return;
  try {
    
  // Card highlight tracker driven by scroll position.
  //   • Desktop (cards in a row): use SECTION SCROLL PROGRESS with a compressed
  //     "cycling window" so all 4 cards highlight in sequence during a single
  //     scroll pass through the section.
  //   • Mobile (cards stacked): use vertical distance to viewport center.
  document.addEventListener('DOMContentLoaded', function () {
    var section = document.querySelector('#grooni-tech-g');
    if (!section) return;
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-grooni-tech-card]'));
    if (!cards.length) return;

    var lastIdx = -1;

    function isHorizontalLayout() {
      if (cards.length < 2) return false;
      var r0 = cards[0].getBoundingClientRect();
      var r1 = cards[1].getBoundingClientRect();
      return Math.abs(r0.top - r1.top) < 10;
    }

    function setActive(idx) {
      if (idx === lastIdx) return;
      lastIdx = idx;
      cards.forEach(function (c, i) {
        c.classList.toggle('grooni-tech__card--active', i === idx);
      });
    }

    function pickActive() {
      var vh = window.innerHeight;
      var sectionRect = section.getBoundingClientRect();

      if (isHorizontalLayout()) {
        // Desktop: compressed scroll-progress cycling.
        var totalDistance = vh + sectionRect.height;
        var scrolled = vh - sectionRect.top;
        var rawProgress = scrolled / totalDistance;
        var CYCLE_START = 0.35;
        var CYCLE_END = 0.75;
        var cycleProgress = (rawProgress - CYCLE_START) / (CYCLE_END - CYCLE_START);
        cycleProgress = Math.max(0, Math.min(0.9999, cycleProgress));
        var idx = Math.floor(cycleProgress * cards.length);
        setActive(idx);
      } else {
        var viewportCenter = vh / 2;
        var closestIdx = 0;
        var closestDist = Infinity;
        cards.forEach(function (c, i) {
          var rect = c.getBoundingClientRect();
          var center = rect.top + rect.height / 2;
          var dist = Math.abs(center - viewportCenter);
          if (dist < closestDist) {
            closestDist = dist;
            closestIdx = i;
          }
        });
        setActive(closestIdx);
      }
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        pickActive();
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    pickActive();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-tech-features"] && !Shopify.designMode) return;
  try {
    
  // Card highlight tracker driven by scroll position.
  //   • Desktop (cards in a row): cards don't move relative to each other
  //     as you scroll, so we use SECTION SCROLL PROGRESS — how far the
  //     section has moved through the viewport — mapped to card indexes.
  //     Result: as you scroll past the section, cards highlight 1 → 2 → 3 → 4.
  //   • Mobile (cards stacked): use vertical distance to viewport center —
  //     each card gets highlighted when it's the one in the middle of view.
  document.addEventListener('DOMContentLoaded', function () {
    var section = document.querySelector('[data-grooni-tech]');
    if (!section) return;
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-grooni-tech-card]'));
    if (!cards.length) return;

    var lastIdx = -1;

    function isHorizontalLayout() {
      if (cards.length < 2) return false;
      var r0 = cards[0].getBoundingClientRect();
      var r1 = cards[1].getBoundingClientRect();
      return Math.abs(r0.top - r1.top) < 10;
    }

    function setActive(idx) {
      if (idx === lastIdx) return;
      lastIdx = idx;
      cards.forEach(function (c, i) {
        c.classList.toggle('grooni-tech__card--active', i === idx);
      });
    }

    function pickActive() {
      var vh = window.innerHeight;
      var sectionRect = section.getBoundingClientRect();

      if (isHorizontalLayout()) {
        // DESKTOP: use section scroll progress, but compress the "cycling window".
        //   • rawProgress: 0 when section top enters viewport → 1 when section bottom exits.
        //   • CYCLE_START (0.35): before this, card 1 stays active. Delays the start
        //     so cards don't flash by while the section is entering view.
        //   • CYCLE_END (0.70): after this, card 4 stays active. Ensures all 4 cards
        //     have cycled before the user reaches the next section below.
        //   • Cards cycle 1→2→3→4 in a compressed window (35% of scroll → ~9% each).
        //     This makes the animation feel snappy and visible in a single scroll pass.
        var totalDistance = vh + sectionRect.height;
        var scrolled = vh - sectionRect.top;
        var rawProgress = scrolled / totalDistance;
        var CYCLE_START = 0.35;
        var CYCLE_END = 0.75;
        var cycleProgress = (rawProgress - CYCLE_START) / (CYCLE_END - CYCLE_START);
        cycleProgress = Math.max(0, Math.min(0.9999, cycleProgress));
        var idx = Math.floor(cycleProgress * cards.length);
        setActive(idx);
      } else {
        // MOBILE: pick the card whose vertical center is closest to viewport center.
        var viewportCenter = vh / 2;
        var closestIdx = 0;
        var closestDist = Infinity;
        cards.forEach(function (c, i) {
          var rect = c.getBoundingClientRect();
          var center = rect.top + rect.height / 2;
          var dist = Math.abs(center - viewportCenter);
          if (dist < closestDist) {
            closestDist = dist;
            closestIdx = i;
          }
        });
        setActive(closestIdx);
      }
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        pickActive();
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    pickActive();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-video-feature"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('[data-grooni-vf]').forEach(function (section) {
      if (section.dataset.grooniInit === '1') return;
      section.dataset.grooniInit = '1';

      var media   = section.querySelector('[data-grooni-vf-media]');
      var html5   = section.querySelector('[data-grooni-vf-html5]');
      var iframe  = section.querySelector('[data-grooni-vf-iframe]');
      var play    = section.querySelector('.grooni-vf__play');
      if (!media || (!html5 && !iframe)) return;

      function startPlay() {
        media.classList.add('is-playing');
        if (html5) {
          var p = html5.play();
          if (p && typeof p.catch === 'function') p.catch(function(){});
        } else if (iframe) {
          var base = iframe.dataset.embedBase || '';
          var sep = base.indexOf('?') !== -1 ? '&' : '?';
          iframe.src = base + sep + 'autoplay=1';
        }
      }

      if (play) play.addEventListener('click', function (e) { e.stopPropagation(); startPlay(); });
      media.addEventListener('click', function (e) {
        if (e.target.tagName === 'VIDEO' || e.target.tagName === 'IFRAME') return;
        if (!media.classList.contains('is-playing')) startPlay();
      });
      if (html5) html5.addEventListener('ended', function () { media.classList.remove('is-playing'); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-video-testimonials"] && !Shopify.designMode) return;
  try {
    
  // Lazy video injection: only create the <video> element on first play click.
  // Keeps initial page load light — no video metadata fetched until watched.
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-grooni-vt] .grooni-vt__media').forEach(function (media) {
      var btn = media.querySelector('[data-grooni-vt-play]');
      var tpl = media.querySelector('[data-grooni-vt-video-template]');
      if (!btn || !tpl) return;

      btn.addEventListener('click', function () {
        var frag = tpl.content.cloneNode(true);
        var video = frag.querySelector('video');
        media.appendChild(frag);
        btn.remove();
        if (video) {
          try { video.play(); } catch (e) {}
        }
        var poster = media.querySelector('.grooni-vt__poster');
        if (poster) poster.style.opacity = '0';
      }, { once: true });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Move nested panels outside of mega-menu container
  document.addEventListener('DOMContentLoaded', function() {
    const submenuWrappers = document.querySelectorAll('.mega-menu__submenu-wrapper');

    submenuWrappers.forEach(wrapper => {
      const panel = wrapper.querySelector('.mega-menu__nested-panel');
      if (!panel) return;

      // Move panel to body (outside of mega-menu container)
      document.body.appendChild(panel);

      // Store reference to wrapper
      panel.dataset.wrapperId = wrapper.dataset.wrapperId || 'wrapper-' + Math.random().toString(36).substr(2, 9);
      wrapper.dataset.wrapperId = panel.dataset.wrapperId;

      wrapper.addEventListener('mouseenter', function() {
        positionNestedPanel(wrapper, panel);
        panel.classList.add('is-visible');
      });

      wrapper.addEventListener('mouseleave', function(e) {
        // Check if mouse is moving to panel
        setTimeout(() => {
          if (!panel.matches(':hover') && !wrapper.matches(':hover')) {
            panel.classList.remove('is-visible');
          }
        }, 100);
      });

      panel.addEventListener('mouseleave', function() {
        if (!wrapper.matches(':hover')) {
          panel.classList.remove('is-visible');
        }
      });
    });

    function positionNestedPanel(wrapper, panel) {
      const megaMenuContent = wrapper.closest('.mega-menu__content');
      const wrapperRect = wrapper.getBoundingClientRect();
      const megaMenuRect = megaMenuContent.getBoundingClientRect();

      // Position panel directly next to the mega menu container (2px gap)
      panel.style.left = (megaMenuRect.right + 2) + 'px';
      panel.style.top = (wrapperRect.top -10) + 'px';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["influencer-videos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('[data-grooni-vt]').forEach(function (section) {
      if (section.dataset.grooniVtBound === '1') return;
      section.dataset.grooniVtBound = '1';

      var carousel    = section.querySelector('[data-grooni-vt-carousel]');
      var prevBtn     = section.querySelector('[data-grooni-vt-prev]');
      var nextBtn     = section.querySelector('[data-grooni-vt-next]');
      var progressBar = section.querySelector('[data-grooni-vt-progress]');

      // ── Lazy video injection on poster click ──
      section.querySelectorAll('[data-grooni-vt-play]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = btn.closest('[data-grooni-vt-card]');
          if (!card) return;
          var media = card.querySelector('.grooni-vt__media');
          var tpl   = card.querySelector('[data-grooni-vt-tpl]');
          if (!media || !tpl) return;

          // Pause any currently-playing testimonial in this section
          section.querySelectorAll('.grooni-vt__video').forEach(function (v) {
            try { v.pause(); } catch (e) {}
          });

          btn.remove();
          media.appendChild(tpl.content.cloneNode(true));
          var v = media.querySelector('video');
          if (v) {
            // preload="none" → only fetch when play() is called
            v.preload = 'metadata';
            v.play().catch(function () { /* autoplay may be blocked; user can press the built-in control */ });
          }
        });
      });

      // ── Read-more summary expand ──
      section.querySelectorAll('[data-grooni-vt-more]').forEach(function (more) {
        more.addEventListener('click', function () {
          var card = more.closest('[data-grooni-vt-card]');
          if (!card) return;
          var sum = card.querySelector('[data-grooni-vt-summary]');
          if (!sum) return;
          var expanded = sum.classList.toggle('grooni-vt__summary--expanded');
          sum.classList.toggle('grooni-vt__summary--clamp', !expanded);
          more.textContent = expanded ? 'Show less' : 'Read more';
        });
      });

      // ── Arrow navigation ──
      if (carousel && (prevBtn || nextBtn)) {
        function step(dir) {
          var firstCard = carousel.querySelector('[data-grooni-vt-card]');
          if (!firstCard) return;
          var w = firstCard.getBoundingClientRect().width + 24; // card + gap
          carousel.scrollBy({ left: w * dir, behavior: 'smooth' });
        }
        if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
        if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

        function updateArrowState() {
          if (!prevBtn || !nextBtn) return;
          var atStart = carousel.scrollLeft <= 2;
          var atEnd   = carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 2;
          prevBtn.toggleAttribute('disabled', atStart);
          nextBtn.toggleAttribute('disabled', atEnd);
        }
        // Update progress bar: width = visible portion of total scroll,
        // left = how far through the user has scrolled. Combined, the pill
        // acts like a custom scrollbar showing position + remaining content.
        function updateProgress() {
          if (!progressBar) return;
          var total = carousel.scrollWidth;
          var view  = carousel.clientWidth;
          if (total <= view + 2) {
            // Nothing to scroll — show full bar
            progressBar.style.width = '100%';
            progressBar.style.left  = '0';
            return;
          }
          var widthPct = (view / total) * 100;
          var maxLeft  = 100 - widthPct;
          var scrolled = carousel.scrollLeft / (total - view); // 0..1
          var leftPct  = scrolled * maxLeft;
          progressBar.style.width = widthPct + '%';
          progressBar.style.left  = leftPct + '%';
        }
        function updateAll() { updateArrowState(); updateProgress(); }
        carousel.addEventListener('scroll', updateAll, { passive: true });
        window.addEventListener('resize', updateAll);
        window.addEventListener('load', updateProgress);
        updateAll();

        // ── Pixel-perfect arrow vertical alignment ──
        // The arrows live in .grooni-vt__carousel-wrap, but they need to
        // land on the poster's vertical center — not on the whole card's
        // center (the body text under the poster would pull them down).
        function positionArrows() {
          var firstMedia = carousel.querySelector('.grooni-vt__media');
          if (!firstMedia) return;
          // y of the media's center relative to the carousel-wrap
          var media = firstMedia.getBoundingClientRect();
          var wrap  = carousel.parentNode.getBoundingClientRect();
          var topPx = (media.top - wrap.top) + (media.height / 2);
          if (prevBtn) prevBtn.style.top = topPx + 'px';
          if (nextBtn) nextBtn.style.top = topPx + 'px';
        }
        // Run once posters/images may have loaded, and again on resize
        positionArrows();
        window.addEventListener('load', positionArrows);
        window.addEventListener('resize', positionArrows);
        // Re-measure when each poster image finishes loading (in case aspect
        // ratio changes layout slightly)
        carousel.querySelectorAll('.grooni-vt__poster').forEach(function (img) {
          if (img.tagName === 'IMG' && !img.complete) img.addEventListener('load', positionArrows);
        });
      }

      // ── ESC pauses everything ──
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        section.querySelectorAll('.grooni-vt__video').forEach(function (v) {
          try { v.pause(); } catch (e) {}
        });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-guides-accordion"] && !Shopify.designMode) return;
  try {
    
(function () {
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSection(section) {
    if (section.dataset.grooniPillarsInit === '1') return;
    section.dataset.grooniPillarsInit = '1';

    var nav      = section.querySelector('[data-grooni-pillars-nav]');
    var viewport = section.querySelector('[data-grooni-pillars-viewport]');
    var tabs     = Array.prototype.slice.call(section.querySelectorAll('[data-grooni-pillars-tab]'));
    var panels   = Array.prototype.slice.call(section.querySelectorAll('[data-grooni-pillars-panel]'));
    var arrows   = Array.prototype.slice.call(section.querySelectorAll('[data-grooni-pillars-scroll]'));
    var deepLink = section.dataset.rememberTab === 'true';

    if (!tabs.length) return;

    function tabFor(target) {
      for (var i = 0; i < tabs.length; i++) {
        if (tabs[i].dataset.target === target) return tabs[i];
      }
      return null;
    }

    function activate(target, opts) {
      opts = opts || {};
      var found = false;

      tabs.forEach(function (t) {
        var on = t.dataset.target === target;
        if (on) found = true;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      if (!found) return;

      panels.forEach(function (p) {
        var on = p.id === target;
        p.classList.toggle('is-active', on);
        if (on) p.removeAttribute('hidden');
        else p.setAttribute('hidden', '');
      });

      var tab = tabFor(target);
      if (tab) {
        try {
          tab.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
        } catch (e) { /* older browsers */ }
        if (opts.focus) tab.focus();
      }

      if (opts.scrollIntoView) {
        var top = section.getBoundingClientRect().top;
        if (top < 0 || top > window.innerHeight * 0.5) {
          try {
            section.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });
          } catch (e) { section.scrollIntoView(); }
        }
      }

      if (deepLink && tab && opts.updateHash !== false && window.history && window.history.replaceState) {
        var slug = tab.dataset.slug;
        if (slug) window.history.replaceState(null, '', '#guide-' + slug);
      }

      syncArrows();
    }

    /* ── Click ── */
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.dataset.target);
      });
    });

    /* ── Keyboard: roving tabindex, manual activation ── */
    section.querySelector('[role="tablist"]').addEventListener('keydown', function (e) {
      var current = tabs.indexOf(document.activeElement);
      if (current === -1) return;
      var next = null;

      switch (e.key) {
        case 'ArrowRight': next = (current + 1) % tabs.length; break;
        case 'ArrowLeft':  next = (current - 1 + tabs.length) % tabs.length; break;
        case 'Home':       next = 0; break;
        case 'End':        next = tabs.length - 1; break;
        case 'Enter':
        case ' ':
          e.preventDefault();
          activate(tabs[current].dataset.target);
          return;
        default: return;
      }

      e.preventDefault();
      tabs.forEach(function (t, i) { t.tabIndex = i === next ? 0 : -1; });
      tabs[next].focus();
      try {
        tabs[next].scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
      } catch (err) { /* noop */ }
    });

    /* ── "Read guide" / prev / next buttons ── */
    section.addEventListener('click', function (e) {
      var trigger = e.target.closest ? e.target.closest('[data-grooni-pillars-goto]') : null;
      if (!trigger || !section.contains(trigger)) return;
      e.preventDefault();
      activate(trigger.getAttribute('data-grooni-pillars-goto'), { scrollIntoView: true, focus: true });
    });

    /* ── Mats / Sheets filter inside a panel ── */
    section.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-shelf-filter]') : null;
      if (!btn || !section.contains(btn)) return;
      var zone = btn.closest('[data-shelf-zone]');
      if (!zone) return;

      var want = btn.getAttribute('data-shelf-filter');
      zone.querySelectorAll('[data-shelf-filter]').forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      zone.querySelectorAll('[data-shelf]').forEach(function (shelf) {
        shelf.hidden = !(want === 'all' || shelf.getAttribute('data-shelf') === want);
      });
      zone.classList.toggle('is-filtered', want !== 'all');
    });

    /* ── Tab strip overflow: arrows + scroll ── */
    function syncArrows() {
      if (!viewport || !nav) return;
      var overflowing = viewport.scrollWidth - viewport.clientWidth > 2;
      nav.classList.toggle('is-scrollable', overflowing);

      arrows.forEach(function (btn) {
        btn.hidden = !overflowing;
        if (!overflowing) return;
        var dir = parseInt(btn.getAttribute('data-grooni-pillars-scroll'), 10);
        var max = viewport.scrollWidth - viewport.clientWidth;
        btn.disabled = dir < 0 ? viewport.scrollLeft <= 1 : viewport.scrollLeft >= max - 1;
      });
    }

    arrows.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = parseInt(btn.getAttribute('data-grooni-pillars-scroll'), 10);
        viewport.scrollBy({ left: dir * Math.max(180, viewport.clientWidth * 0.7), behavior: REDUCED ? 'auto' : 'smooth' });
      });
    });
    if (viewport) viewport.addEventListener('scroll', syncArrows, { passive: true });
    if (window.ResizeObserver && viewport) {
      new ResizeObserver(syncArrows).observe(viewport);
    } else {
      window.addEventListener('resize', syncArrows);
    }
    syncArrows();

    /* ── Deep link on load (#guide-<slug>) ── */
    if (deepLink && window.location.hash.indexOf('#guide-') === 0) {
      var wanted = window.location.hash.replace('#guide-', '');
      var match = tabs.filter(function (t) { return t.dataset.slug === wanted; })[0];
      if (match) activate(match.dataset.target, { scrollIntoView: true, updateHash: false });
    }

    /* ── Theme editor: selecting a block opens its panel ── */
    section.__grooniActivate = activate;
  }

  function initAll() {
    document.querySelectorAll('[data-grooni-pillars]').forEach(initSection);
  }

  function handleBlockSelect(evt) {
    var el = evt.target;
    if (!el || !el.closest) return;
    var section = el.closest('[data-grooni-pillars]');
    if (!section || !section.__grooniActivate) return;
    var panel = el.closest('[data-grooni-pillars-panel]');
    if (panel && panel.id) section.__grooniActivate(panel.id);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', handleBlockSelect);
})();

  } catch(e) { console.error(e); }
})();
})();
